import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionPricingService {
  // inject needed services
  private http: HttpClient = inject(HttpClient);

  adminList(schoolType?): Observable<any> {
    return this.http.get(`${environment.api}/subscriptionpricing/adminlist?type=${schoolType}`);
  }
}
